import { render, staticRenderFns } from "./KimStatsComponent.vue?vue&type=template&id=d4ba81ac&scoped=true"
import script from "./KimStatsComponent.vue?vue&type=script&lang=ts"
export * from "./KimStatsComponent.vue?vue&type=script&lang=ts"
import style0 from "./KimStatsComponent.vue?vue&type=style&index=0&id=d4ba81ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ba81ac",
  null
  
)

export default component.exports